import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.NoOversizeMaterial`]: 'No oversize material',
      [`${prefix}.Sieves[0].CumulativeDryMassPassingPercent`]: 'Passing 37.5mm',
      [`${prefix}.Sieves[1].CumulativeDryMassPassingPercent`]: 'Passing 20mm',
      [`${prefix}.Sieves[0].CumulativeDryMassRetainedPercent`]: 'Retained 37.5mm',
      [`${prefix}.Sieves[1].CumulativeDryMassRetainedPercent`]: 'Retained 20mm',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Sieves.CumulativeWetMassRetainedPercent`]: '%',
      [`${prefix}.Sieves.CumulativeDryMassPassingPercent`]: '%',
      [`${prefix}.Sieves.CumulativeDryMassRetainedPercent`]: '%',
    })
  );

export default getLabelConfig;
